import { PayloadAction } from '@reduxjs/toolkit';
import { CoarchingStaff, ManagingStaff, StaffGroup, StaffState } from '../state';

export const fetchStaff = (state: StaffState, action: PayloadAction<{managing: ManagingStaff[], coarching: CoarchingStaff[] }>) => {
    state.managing = action.payload.managing;
    state.coaching = action.payload.coarching;
}

export const changeSelectedGroup = (state: StaffState, action: PayloadAction<StaffGroup>) => {
    state.group = action.payload;
}
